// String params pass through (blank/whitespace included); non-strings → null (avoids .toString() on undefined).
export const getSsoParam = (value: unknown): string | null =>
    typeof value === "string" ? value : null;

/**
 * True only for an absolute `https://` redirect target. Rejects relative URLs,
 * `http:`, `javascript:`, `data:` and malformed values. Validate the RAW action
 * attribute (not `form.action`, which the browser resolves to an absolute URL).
 */
export const isSafeSsoRedirect = (url: string | null | undefined): boolean => {
    if (!url) return false;
    try {
        return new URL(url).protocol === "https:";
    } catch {
        return false;
    }
};
